<template>
    <div>
        <div class="pt-[20px] pr-[0px] bg-[#ededed]">
            <div class="max-w-[1400px] w-full container mx-auto">
                <div class="lg:pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]">
                    <offerNavigation />
                </div>
            </div>
        </div>
        <div class="max-w-[1400px] w-full container mx-auto">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
            <div class="pt-[30px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px] text-center">
                <FullButton
                    data-cy="newOfferButton"
                    :link="'/offers/selectcontacts/'"
                    width="100"
                    title=" Neue Offerte erstellen +"
                    colour="white"
                />
                <h2 class="text-left text-2xl font-light my-[3%]">
                    <strong>{{ $t('offers.contactsWithOffers') }}</strong>
                </h2>
                <v-card class="w-full mx-auto" color="grey-lighten-3">
                    <v-card-text>
                        <v-text-field
                            :loading="loading"
                            density="comfortable"
                            type="input"
                            @input="search()"
                            variant="solo"
                            :label="$t('offers.pleaseSelectSchool')"
                            :title="$t('offers.enterSchool')"
                            autofocus
                            v-model="searchTerm"
                            append-inner-icon="mdi-magnify"
                            single-line
                            hide-details
                            data-cy="offer-search"
                        ></v-text-field>
                    </v-card-text>
                </v-card>
                <ContactsTable
                    :load="loadOffers"
                    :hasActions="true"
                    :deleteMethod="deleteOffers"
                    :contacts="offers"
                    :selectMethod="selectContact"
                    :duplicateMethod="duplicateContact"
                    :contactsCount="50"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import offerNavigation from '@/components/SubNavigations/TheOfferNavigation.vue'
    import ContactsTable from '@/components/Contacts/ContactsTable.vue'
    import FullButton from '@/components/Buttons/FullButton.vue'
    import router from '@/router'
    import useOfferStore from '@/utils/useOfferStore'
    import useContactStore from '@/utils/useContactStore'
    import { Offer } from '@/model/types'

    // Composable functions for offers and search
    const { offers, loading, fetchOffers, loadOffers, deleteOffers, searchTerm, search } =
        useOfferStore()
    const { duplicateContact } = useContactStore()

    // Fetch offers on component mount
    async function fetchDataOnMounted() {
        await fetchOffers()
    }

    fetchDataOnMounted()

    function selectContact(offer: Offer) {
        router.push('/offers/schoolview/' + offer.contactId)
    }

    //breadcrumbs
    const breadcrumbs = [
        {
            title: 'Offerten',
            disabled: false,
            href: 'offers',
        },
    ]
</script>
